import { fetchHelper } from "../utils"

export const signInAsync = async (body: {
    email: string,
    password: string,
    platform: string,
    courseId: string | undefined

}) => {
    return fetchHelper({
        url: 'auth/signin',
        method: 'POST',
        body
    }) as Promise<any>
}